module.exports = __webpack_public_path__ + "images/柏纳长图_02.jpg?v=96eda347";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_02.jpg
 ** module id = 137
 ** module chunks = 1 2
 **/